import React, { useEffect, useState, useContext} from "react";

import { DialogueContext } from "../Landing";


import { withStyles } from "@material-ui/core";
import Mic from "@material-ui/icons/Mic";
import MicOff from "@material-ui/icons/MicOff";
import Videocam from "@material-ui/icons/Videocam";
import VideocamOff from "@material-ui/icons/VideocamOff";

import VolumeUp from "@material-ui/icons/VolumeUp";
import VolumeOff from "@material-ui/icons/VolumeOff";
import CheckCircle from "@material-ui/icons/CheckCircle";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import DragArrows from './move.svg';
import PhoneDown from './redphone36px.svg';

import CircularProgress from "@material-ui/core/CircularProgress";

import JitsiComponent from "./jitsi-component";
import LiveFeed from "./LiveFeed";


import Draggable from "react-draggable";


const styles = {
    LiveAssistanceDialogue: {
        width: "920px",
        height: "52px",
        border: "1px solid lightgrey",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-betwen",
        position: "absolute",
        top: "225px",
        left: "100px",
        zIndex: "30",
        backgroundColor: "white",
        filter: "drop-shadow(2px 2px 4px #4444dd22)",
    },

    LADexpanded: {
        height: "580px"
    },

    nav: {
        width: "100%",
        height: "52px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    move: {
        height: "36px",
        width: "36px",
        display: "grid",
        placeItems: "center",        
        cursor: "move",
        
        "& img": {
            height: "20px",
            width: "20px",
            marginLeft: "16px",
            },
    },

    hangUp: {
        backgroundColor: "#eb3c39",
        borderRadius: "3px",
        display: "grid",
        placeItems: "center",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#c62828",
            }
    },

    timer: {
        width: "28px",
        fontSize: "14px",
        lineheight: "14px",
        color: "black",
        marginRight: "32px",
        paddingTop: "4px"
    },
      
    mediaControls: {
        width: "180px",
        margin: "0px 30px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },

    control: { 
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    
    checkboxContainer : {
        width: "24px",
        height: "24px",
        display: "grid",
        placeItems: "center",
    },

    checkbox: {
        height: "18px",
        width: "18px",
        cursor: "pointer",
        filter: "hue-rotate(165deg)",
    },

    mediaIcon: {
        height: "24px",
        width: "24px",
        display: "grid",
        placeItems: "center",
    },

    location: {
        textAlign: "left",
        fontSize: "14px"
    },
      
    admission: {
        
        
        "& button": {
            color: "white",
            width: "100px",
            height: "36px",
            border: "none",
            borderRadius: "3px",
        },

    },

    buttonContent: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    buttonIcon: {
        width: "18px",
        height: "18px",
    },

    admissionText: {
        height: "18px",
        lineheight: "22px",
        paddingLeft: "8px",
    },
      
    deny: {
        backgroundColor: "#eb3c39",
        marginRight: "8px",

        "&:hover": {
            backgroundColor: "#c62828",
        }
    },
      
    allow: {
        backgroundColor: "#68ac58",
        marginRight: "8px",

        "&:hover": {
            backgroundColor: "#2e7d32",
        },
    },
    
    videoFeed: {
        height: "520px",
        width: "100%",
        "& video": {
            height: "520px",
            width: "100%",
            },
    },

    connecting: {
        width: "920px",
        backgroundColor: "#686868",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },

    hidden: {
        visibility: "hidden",
        height: "1px",
        "& video": {
            height: "100%",
            width: "100%",
            },
    }
      
  };

JitsiComponent.addEventListener(JitsiComponent.EVENT_CONSOLE_CONNECTING, () => {
    console.log('connecting');
})
JitsiComponent.addEventListener(JitsiComponent.EVENT_CONSOLE_CONNECTED, () => {
    console.log('connected');
})
JitsiComponent.addEventListener(JitsiComponent.EVENT_CONSOLE_DISCONNECTED, () => {
    console.log('disconnected :(');
})
  

const LiveAssistanceDialogue = props => {

    const {showLiveAssistanceDialogue, setShowLiveAssistanceDialogue}  = useContext(DialogueContext)

    const {classes} = props;

    const [isMicAllowed, setIsMicAllowed] = useState(true);
    const [isAudioAllowed, setIsAudioAllowed] = useState(true);

    const [showDisplay, setShowDisplay] = useState(false)

    const [isFetchingMediaStream, setIsFetchingMediaStream] = useState(true)

    const handleEndConference = () => {
        setShowLiveAssistanceDialogue()
        setIsFetchingMediaStream(true)
    }

    const handleDisplayOpen = () => {
        showDisplay ? setShowDisplay(false) : setShowDisplay(true)
        !isFetchingMediaStream ? setIsFetchingMediaStream(true) : setIsFetchingMediaStream(false)
    }

    const handleMic = () => {
    isMicAllowed ? setIsMicAllowed(false) : setIsMicAllowed(true)
    }
    
    const handleAudio = () => {
    isAudioAllowed ? setIsAudioAllowed(false) : setIsAudioAllowed(true)
  }

  useEffect(() => {
        // if (showLiveAssistanceDialogue) {
        //     // Start up the connection and setup the conference then join it.
        //     let serverURL = 'https://dev1.conference1.nuvoola.ai'; // todo: get this from LUKE for the zone.
        //     let roomName = 'test' // todo: get this from LUKE for the zone.
        //     let intercomNumber = '551' // todo: get this from LUKE for the zone.
        //     JitsiComponent.init(serverURL, intercomNumber, roomName);
        //     if (!JitsiComponent.isConnected()) {
        //         JitsiComponent.connect();
        //         JitsiComponent.getLocalTracks();
        //     }
        // } else {
        //     // Shutdown the conference and disconnect from the conferencing server.
        //     if (JitsiComponent.isConnected()) {
        //         JitsiComponent.disconnect();
        //     }
        // }
    });

    useEffect(()=> {
        
    }, [])


    return (
        <>
            {showLiveAssistanceDialogue ? 
            <Draggable handle="strong">
            <div className={classes.LiveAssistanceDialogue + (showDisplay ? " " + classes.LADexpanded : "")}>
                <div className={classes.nav}>
                    <strong>
                    <div className={classes.move} >
                        <img src={DragArrows} alt="Move Assistance Dialogue" />
                    </div>
                    </strong>

                    

                    <div className={classes.hangUp} onClick={handleEndConference}>
                        <img src={PhoneDown} alt="Move Assistance Dialogue" />
                    </div>

                    <div className={classes.timer}>
                        {"0:28"}
                    </div>

                    <div className={classes.mediaControls} >
                        
                        <div className={classes.control}>
                            {showDisplay ? 
                            <div className={classes.mediaIcon}>
                                <Videocam style={{ color: '#68ac58' }} />
                            </div>
                            :
                            <div className={classes.mediaIcon}>
                                <VideocamOff style={{ color: 'black' }} />
                            </div>
                            }
                            <div className={classes.checkboxContainer}>
                            <input type="checkbox" className={classes.checkbox} checked={showDisplay} onClick={handleDisplayOpen}></input>
                            </div>
                        </div>

                        <div className={classes.control}>
                            {isMicAllowed ? 
                            <div className={classes.mediaIcon}>
                                <Mic style={{ color: '#68ac58' }} />
                            </div> 
                            :
                            <div className={classes.mediaIcon}>
                                <MicOff style={{ color: 'black' }} />
                            </div>}
                            
                            <input type="checkbox" className={classes.checkbox} checked={isMicAllowed} onClick={handleMic}></input>
                        </div>

                        <div className={classes.control}>
                            {isAudioAllowed ? 
                            <div className={classes.mediaIcon}>
                                <VolumeUp style={{ color: '#68ac58' }} />
                            </div>
                            :
                            <div className={classes.mediaIcon}>
                                <VolumeOff style={{ color: 'black' }} />
                            </div>}

                            <input type="checkbox" className={classes.checkbox} checked={isAudioAllowed} onClick={handleAudio}></input>
                        </div>

                    </div>

                    <div className={classes.location}>
                    
                        <div>{`Site: ${"Sobeys Entrepot"}`}</div>
                        <div>{`Zone: ${"Entrance"}`}</div>
                    </div>

                    <div className={classes.admission}>
                    <button className={classes.deny}>
                        <div className={classes.buttonContent}>
                            <div className={classes.buttonIcon}>
                                <RemoveCircle style={{ width: '18px', height: '18px' }}/>
                            </div>
                            <p className={classes.admissionText}>DENY</p>
                        </div>
                        </button>
                    <button className={classes.allow}>
                        <div className={classes.buttonContent}>
                            <div className={classes.buttonIcon}>
                                <CheckCircle style={{ width: '18px', height: '18px' }}/>
                            </div>
                            <p className={classes.admissionText}>ALLOW</p>
                        </div>
                    </button>
                    </div>
                </div>
            {
                showDisplay ? 
                !isFetchingMediaStream ?
                <div className={classes.videoFeed} >
                    <LiveFeed />
                </div> : 
                <div className={classes.connecting}> 
                    <CircularProgress size={30} />
                    <div>Establishing Connection</div>
                </div>
                : <div className={classes.hidden} >
                        <LiveFeed />
                    </div>
            }
                
            </div>
            </Draggable>
            : null}
        </>
    );
    }


  
export default withStyles(styles)(LiveAssistanceDialogue);